"use client";

import { useState } from "react";
import ApplicationForm from "./ApplicationForm";
import { EnvelopeIcon } from "@heroicons/react/24/outline";

export default function ApplyBtn({ jobPostId }: { jobPostId: string }) {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <button
        type="button"
        className="flex w-full items-center justify-center space-x-2 rounded-lg bg-sky-500 px-4 py-4 text-center text-xl font-medium text-white shadow hover:bg-sky-800 focus:outline-none focus:ring-4 focus:ring-blue-300"
        aria-haspopup="dialog"
        aria-labelledby="Apply now to job posting"
        onClick={() => setShowModal(true)}
      >
        <EnvelopeIcon className="inline-block h-6 w-6" />
        <span>Apply Now</span>
      </button>

      <Modal isOpen={showModal} onClose={() => setShowModal(false)}>
        <ApplicationForm jobPostId={jobPostId} />
      </Modal>
    </>
  );
}

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-2">
      <div className="relative w-full max-w-lg rounded-lg bg-white p-4 shadow-lg md:p-8">
        <button
          className="absolute right-0 top-0 m-4 text-gray-600 hover:text-gray-800"
          onClick={onClose}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        {children}
      </div>
    </div>
  );
};
